<template>
  <main
    :class="['home-page-container', isMobile ? '' : 'desktop', layoutVersion]"
  >
    <NEWPcHeader
      v-if="!isMobile"
      ref="homeHeader"
      @login="getLoginResult"
      :class="headerClass"
    />
    <HeaderBar
      v-else
      @login="getLoginResult"
      ref="homeHeader"
      :class="headerClass"
    />
    <client-only>
      <Index2
        :listIsLoading="listIsLoading"
        :bannerList="bannerList"
        :gameList="gameList"
        @goLogin="goLogin"
        @jumpProductDetail="jumpProductDetail"
        :toastConfig="toastConfig"
      />
    </client-only>
    <client-only>
      <PublicFooter page="home" />
    </client-only>
    <CouponNotice :loginStatus="!!(userInfo && userInfo.kicoinId)" />
    <Banner page="home" ref="homeBanner" @login="login" />
    <MembersModalBox />
    <CrmElasticLayer :pageType="1" />
    <PopupList ref="popupList" :pageType="1" @login="loginPopuplist" />
  </main>
</template>

<script>
  import Index2 from './index2'
  import HeaderBar from './component/header'
  import PublicFooter from '@/components/PublicFooter'
  import CouponNotice from '@/components/CouponNotice'
  import Banner from '@/components/Banner'
  import MembersModalBox from '@/pages/Members/components/ModalBox'
  import CrmElasticLayer from '@/components/CrmElasticLayer'
  import membersMixins from '@/mixins/members'
  import PopupList from '@/components/PopupList'
  import { getLoginStatus } from '@/utils/login'
  import { fixSource } from '@/utils/request_helper.js'
  import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
  import { compressBannerImg } from '@/utils/webp'
  import {
    mounted_track,
    shareSuccess,
    fission_share_success,
  } from '../firebase'
  import { fetchBasicConfig } from '@/api/home'
  import NEWPcHeader from '@/pages/Detail/components/NEWPcHeader/index.vue'

  export default {
    name: 'home',
    mixins: [membersMixins],
    components: {
      Index2,
      HeaderBar,
      PublicFooter,
      CouponNotice,
      Banner,
      MembersModalBox,
      PopupList,
      NEWPcHeader,
      CrmElasticLayer,
    },
    head() {
      return this.$getSeoHead('home', this.region)
    },
    data() {
      return {
        showPrivacyPolicy: false,
        headerHeight: 0, // header的高度
        headerClass: '', // header是否滚动到指定位置的类名
        bannerList: [],
        gameList: [],
        listIsLoading: true,
        toastConfig: {},
      }
    },
    computed: {
      ...mapState([
        'source',
        'isPwa',
        'region',
        'isMobile',
        'userInfo',
        'allowUseMember',
        'layoutVersion',
        'isDesktop',
      ]),
      ...mapGetters(['isLogin']),
    },
    created() {
      if (!process.client) return
      const { source = 'xm-MVP', channelId } = this.$route.query
      this.setSource(source)
      if (source === 'share') {
        shareSuccess({ page: 'home', share_name: channelId })
        fission_share_success({
          page: 'home',
          share_name: channelId,
        })
      }
    },
    mounted() {
      mounted_track({ page: 'home' }, 'site-policy')
      this.$nextTick(() => {
        this.headerHeight = this.$refs.homeHeader.$el.offsetHeight || 0
        window.addEventListener('scroll', this.scroll, true)
      })
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scroll)
    },
    methods: {
      ...mapActions(['getWalletBalance']),
      ...mapMutations(['setSource', 'setHomeGameList']),
      jumpProductDetail(item) {
        let source = (fixSource({ source: this.source }) || {}).source
        if (!source || source === 'undefined' || source === '') {
          source = 'xm-MVP'
        }
        let query = { source }
        const mode = this.$route?.query?.mode || ''
        if (mode) {
          query = { ...query, mode }
        }
        this.isPwa && Object.assign(query, { isPwa: true })
        this.showPrivacyPolicy && Object.assign(query, { home: true })
        this.$refs.homeBanner && this.$refs.homeBanner.jumpPage(item, query)
      },
      scroll() {
        const scrollTop = document.documentElement.scrollTop || 0
        this.headerClass = scrollTop > this.headerHeight / 2 ? 'scroll' : ''
      },
      getLoginResult(data) {
        // 获取banner数据 切换登录状态时，重新调用banner接口
        this.getBannerDatas()
        if (data.status === 1 && this.allowUseMember) {
          this.getWalletBalance()
        }
      },
      goLogin(options) {
        this.$refs.homeHeader && this.$refs.homeHeader.login(options)
      },
      login() {
        if (getLoginStatus()) return
        this.goLogin({ type: 'banner' })
      },
      // 弹框登录
      loginPopuplist(params) {
        if (getLoginStatus()) return
        this.goLogin(params)
      },

      getBannerDatas() {
        const { source = '' } = this.$route.query
        // source：根据地址栏是否包含source区分
        this.listIsLoading = true
        fetchBasicConfig({
          country: this.region,
          source,
        })
          .then(async (res) => {
            const { bannerConfig = {}, toastConfig } = res || {}
            const { gameListBanners, homePageBanners } = bannerConfig
            let _homePageBanners = this.hackHidePhoneBanners(homePageBanners)
            let bannerList = await compressBannerImg(_homePageBanners)
            this.bannerList = bannerList
            this.gameList = gameListBanners || []
            this.setHomeGameList(this.gameList)
            this.toastConfig = toastConfig
          })
          .finally(() => {
            this.listIsLoading = false
          })
      },

      // warn：[PC] 针对绑定手机号信息的banner不显示@陈才
      hackHidePhoneBanners(banners) {
        if (banners && banners.length) {
          const result = banners.filter((item) => {
            if (item.url) {
              return item.url && item.url.indexOf('bind-mobile-phone') === -1
            }
            return item
          })
          return this.isDesktop ? result : banners
        }
        return []
      },
    },
  }
</script>
<style scoped lang="scss">
  .home-page-container {
    width: 100%;
    padding-bottom: 260px;
    background: $background-primary;
    box-sizing: border-box;
    &.version-2 {
      min-height: 100vh;
      background: top/contain no-repeat
        url('~@/assets/images/home/background.png') $background-primary;
    }
    &.version-2-2 {
      background: $bg-color-light;
    }
    &.desktop {
      padding-bottom: 77px;
      min-width: 680px; // .banner-wrapper 限制了最小宽度为 620px, 水平外边距 30px * 2
      min-height: 100vh; // 防止内容较少的时候在某些显示屏上底部出现留白
    }
  }
</style>
